(ns ycweb.app.website.myaccount.profile.profile
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.crop :as awm.crop]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [util.string :as str]
   [ycweb.util.hash :as hash]))

(rum/defcs account-settings < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        user-atom (rum/cursor-in action-atom [:user])
        node-atom (::node-atom local-atom)

        user (rum/react user-atom)
        public-id (cmn/curact action-atom [:user :ent/image :doc/public-id])]

    [:div.dashboard
     [:header.dashboard
      (headings/heading "Account Settings" {:type :h2 :size :medium :class "u-margin-bottom-40"})]

     [:aside.user-block-wrapper
      [:div.user-block.user-block--editable
       [:figure.user-block__image-wrapper
        (web-common/user-avatar
          (assoc user :user/public-id public-id)
          {:width 100 :height 100})]
       [:div.user-block__field-wrapper
        [:div.user-block__field
         (buttons/button-web "Upload image"
           {:style :primary :size :default
            :on-click #(grid/dispatch-action app-atom :web.myaccount.accountsettings/upload-pic {})})
         [:div.form-hint-wrapper
          [:span.form-hint
           [:span.clip-text.unclip-text--s
            "Image should be "]
           "minimun 300 x 300px"]]]]]]

     [:form.form.u-max-width-480
      {:ref (fn [node] (reset! node-atom node))}
      (forms/split-input-field
        ["First name:" "e.g. Jane"
         (rum/cursor user-atom :user/firstname)
         {:type :user :id :firstname :name :firstname :required? true}]
        ["Last name:" "e.g. Smith"
         (rum/cursor user-atom :user/lastname)
         {:type :user :id :lastname :name :lastname :required? true}])

      (forms/input "Email address:" "e.g. jane.smith@domain.com"
        (rum/cursor user-atom :user/email)
        {:type :email
         :id :email
         :name :email
         :required? true
         :hint "Note: Use your email address to log into your account."})

      (forms/input "Telephone number:" "e.g. 021 000 0000"
        (rum/cursor user-atom :user/tel)
        {:type :phone
         :id :tel
         :name :tel})

      (forms/input "Cellphone number:" "e.g. 083 000 0000"
        (rum/cursor user-atom :user/cell)
        {:type :phone
         :id :cell
         :name :cell})

      (forms/input "Work telephone number:" "e.g. 021 000 0000"
        (rum/cursor user-atom :user/worktel)
        {:type :phone
         :id :worktel
         :name :worktel})

      [:div.form-field
       [:label.form-label
        {:id "profile_birthday"
         :for "birthday"}
        "Birthday:"]
       [:div
        {:class (u/bem :flex-grid-group [:align-left :valign-middle :flush-force])}
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (forms/select-raw
            (rum/cursor user-atom :user/birthday)
            (concat
              [{:value "" :text ""}]
              (for [x (range 1 32)]
                {:value x :text (str x)}))
            {:inline? true})]]

        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (forms/select-raw
            (rum/cursor user-atom :user/birthmonth)
            [{:value "" :text ""}
             {:value 1 :text "January"}
             {:value 2 :text "February"}
             {:value 3 :text "March"}
             {:value 4 :text "April"}
             {:value 5 :text "May"}
             {:value 6 :text "June"}
             {:value 7 :text "July"}
             {:value 8 :text "August"}
             {:value 9 :text "September"}
             {:value 10 :text "October"}
             {:value 11 :text "November"}
             {:value 12 :text "December"}]
            {:inline? true})]]

        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (forms/select-raw
            (rum/cursor user-atom :user/birthyear)
            (concat
              [{:value "" :text ""}]
              (->>
                (dt/year (dt/now))
                (range 1910)
                (reverse)
                (map (fn [y] {:value y :text (str y)}))))
            {:inline? true})]]]]

      (forms/textarea "Bio: (optional)"
        (rum/cursor user-atom :user/bio)
        {:id :bio
         :name :bio
         :rows "5"})

      [:div.form-field
       (forms/checkbox "Update your password" (rum/cursor user-atom :user/change-password)
         {:id :password-checkbox
          :name :radio})]

      (when
        (:user/change-password user)
        (list
          (forms/password-input "New password:" "Enter your new password"
            (rum/cursor user-atom :user/pwd)
            {:required? true
             :yc-input? true})
          (forms/password-input "Confirm new password:" "Re-enter your new password"
            (rum/cursor user-atom :user/confpwd)
            {:required? true
             :yc-input? true})))

      [:div.form-control
       (buttons/button-web "Save settings"
         {:on-click
          (forms/form-validate node-atom #(grid/dispatch-action app-atom :web.myaccount.accountsettings/save {:user user}))
          :type :button
          :style :primary
          :size :default})]]
     (toaster/loading-overlay app-atom :web.myaccount/accountsettings)]))

(defmethod t/transition-open :web.myaccount/accountsettings [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/accountsettings)
  (comms/ajax-get :web.myaccount/accountsettings {}))

(defmethod flow/render-screen :web.myaccount/accountsettings [app-atom _]
  (awm.common/screen-wrapper app-atom
    (account-settings app-atom)))

(defmethod comms/receive :web.myaccount/accountsettings [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/accountsettings)
  (swap! (cmn/action-cursor app-atom) assoc :user (:user e)))

;;save
(defmethod grid/action :web.myaccount.accountsettings/save [app-atom config _]
  (let [user (:user config)]
    (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
    (comms/ajax-post :web.myaccount/accountsettingssave
      {:user
       (assoc
         user
         :user/pwd (when (:user/change-password user) (hash/md5 (:value (:user/pwd user))))
         :user/confpwd (when (:user/change-password user) (hash/md5 (:value (:user/confpwd user)))))})))

(defmethod comms/receive :web.myaccount/accountsettingssave [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))

(defn rotate-image [nodes-atom]
  (swap! nodes-atom update :orientation (comp #(if (> % 4) 1 %) inc))
  (let [{:keys [img encoded orientation crop]} @nodes-atom
        [imgwidth imgheight] (:imgsize crop)]
    (when encoded
      (awm.crop/reset-orientation encoded orientation
        (fn [rotated width height]
          (swap! nodes-atom
            (fn [n]
              (let [imagesize
                    (cond
                      (< width height)
                      {:width (/ width (/ height imgheight)) :height imgheight}

                      (> width height)
                      {:width imgwidth :height (/ height (/ width imgwidth))}

                      :else
                      {:width (/ width (/ height imgheight)) :height (/ height (/ width imgwidth))})]
                (->
                  n
                  (assoc :rotated rotated)
                  (assoc-in [:crop :imgsize] [(:width imagesize) (:height imagesize)])
                  (assoc-in [:crop :p1]
                    (cond
                      (< (:width imagesize) (:height imagesize))
                      [10 (- (/ (:height imagesize) 2) (/ (- (:width imagesize) 10) 2))]

                      (> (:width imagesize) (:height imagesize))
                      [(- (/ (:width imagesize) 2) (/ (- (:height imagesize) 10) 2)) 10]

                      :else
                      [10 10]))
                  (assoc-in [:crop :p2]
                    (cond
                      (< (:width imagesize) (:height imagesize))
                      [(- (:width imagesize) 10)
                       (+ (/ (:height imagesize) 2) (/ (- (:width imagesize) 10) 2))]

                      (> (:width imagesize) (:height imagesize))
                      [(+ (/ (:width imagesize) 2) (/ (- (:height imagesize) 10) 2))
                       (- (:height imagesize) 10)]

                      :else
                      [(- (:width imagesize) 10) (- (:height imagesize) 10)])))))))))))

(defn load-image [nodes-atom app-atom]
  #?(:cljs
     (let [{:keys [file img orientation]} @nodes-atom
           allowed-types (u/get-allowed-types :image)]
       (when (and (.-files file) (aget (.-files file) 0))
         (let [selected-file (aget (.-files file) 0)]
           (cond
             (contains? allowed-types (.-type selected-file))
             (let [reader (js/FileReader.)]
               (set! (.-onload reader)
                 (fn [e]
                   (let [b64 (.-result (.-target e))]
                     (swap! nodes-atom assoc :encoded b64 :orientation 0)
                     (rotate-image nodes-atom))))
               (.readAsDataURL reader (aget (.-files file) 0)))

             :else
             (toaster/open-toast app-atom :error "Please select a valid image file (JPG, PNG, or GIF)" {:closetime 3000})))))))

;; upload pic
(rum/defcs upload-profile-pic-modal-body <
  rum/reactive
  (cmn/local
    {:orientation 1
     :crop {:p1 [10 10] :p2 [220 220] :imgsize [240 240] :targetsize [240 240]}} ::nodes)
  [local-atom app-atom config-atom]
  (let [cropped (cmn/curact (::nodes local-atom) [:cropped])]
    [:div
     (headings/heading "Upload a profile picture"
       {:type :h2
        :size :small})
     [:form.form.u-max-width-480
      {:method "post" :encType "multipart/form-data" :action "myaccount.htm?action=photoUpload"}
      [:div.form-field
       [:label.form-label "Select an image from your computer:"]
       [:div.yc-text-input-wrapper
        [:input.yc-text-input
         {:type "file"
          :name "myfile"
          :accept (str/join "," (u/get-allowed-types :image))
          :ref (fn [dom-or-nil] (swap! (::nodes local-atom) assoc :file dom-or-nil))
          :on-change #(load-image (::nodes local-atom) app-atom)}]]
       [:div.form-hint-wrapper
        [:span.form-hint [:b "Note:"] "Image must be 4MB max and either JPG, PNG or GIF"]]]

      (when (cmn/curact (::nodes local-atom) [:encoded])
        (list
          [:div
           {:class (u/bem :flex-grid-group [:align-left :flush])}
           [:div
            {:class (u/bem :flex-grid-block [:m-1-2 :flush])}
            [:div.flex-grid-content
             [:div.form-field
              (awm.crop/crop-pic (::nodes local-atom))]]]
           (when cropped
             [:div
              {:class (u/bem :flex-grid-block [:m-1-2 :flush])}
              [:div.flex-grid-content
               [:div.form-field.u-max-width-180
                {:style {:margin "auto"}}
                [:label.form-label
                 "Preview:"]
                [:img.avatar
                 {:src cropped
                  :class (u/bem :yc-simple-image [:full :border :shadow])}]]]])]
          [:div.form-field.button-group
           (buttons/button-web "Rotate 90"
             {:style :secondary :size :small
              :on-click (fn [e] (.preventDefault e) (rotate-image (::nodes local-atom)))
              :class "u-margin-right-10"})
           (buttons/button-web "Crop and preview"
             {:style :primary :size :small
              :on-click
              (fn [e]
                (.preventDefault e)
                (awm.crop/write-cropped (::nodes local-atom)
                  (fn [b64]
                    (swap! (::nodes local-atom) assoc :cropped b64))))})]

          (when (cmn/curact (::nodes local-atom) [:cropped])
            [(buttons/button-web "Upload"
               {:style :primary :size :default
                :on-click
                (fn [e]
                  (.preventDefault e)
                  (grid/dispatch-action app-atom :web.myaccount.accountsettings/uploadprofilepic
                    {:data (:cropped @(::nodes local-atom))}))
                :class "u-margin-top-20  u-margin-bottom-10"})
             [:br]])))

      [:small "By uploading an image you certify that you have the right to use it."]]]))

(defmethod grid/modal-config :accountsettings/upload-profile-pic [_ _ _]
  {:body upload-profile-pic-modal-body
   :modal-type :alert})

(defmethod grid/action :web.myaccount.accountsettings/upload-pic [app-atom _ _]
  (grid/open-modal app-atom :accountsettings/upload-profile-pic {}))

(defmethod grid/action :web.myaccount.accountsettings/uploadprofilepic [app-atom config]
  (let [state-atom (cmn/action-cursor app-atom)
        image-uuid (cmn/curact state-atom [:user :ent/image :ent/uuid])]
    (toaster/open-toast app-atom :processing "Uploading image" {:closetime 10000})
    (comms/ajax-post :web.myaccount/upload-profilepic
      {:ent/uuid image-uuid
       :ent/image {:doc/data (:data config)}})))

(defmethod comms/receive :web.myaccount/upload-profilepic [app-atom e]
  (let [public-id (get-in e [:user :ent/image :doc/public-id])]
    (toaster/close-toast app-atom)
    (grid/close-modal app-atom)
    (swap! (cmn/action-cursor app-atom) assoc-in [:user :ent/image :doc/public-id] public-id)))
